var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-modal"},[_c('div',{staticClass:"insight-modal__inner"},[_c('content-header',{attrs:{"title":_vm.title,"returnRoute":"home","returnRouteGoTo":"insight-widget"}}),_vm._v(" "),_c('div',{staticClass:"insight-modal__content"},[_c('iframe',{staticClass:"insight-modal__iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62e33c59","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/insight/insight-modal/insight-modal.vue
// module id = cole
// module chunks = 0